import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "daster",
  style: {"padding":"0 30px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "d-flex flex-wrap flex-stack" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title mb-4" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "mb-0 text-fprimary" }, "Personas"),
    /*#__PURE__*/_createElementVNode("span", null, "Permite administrar los datos personales de los participantes")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "options" })
], -1)
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-6" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_7 = {
  class: "",
  style: {"line-height":"1.25"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "symbol symbol-30 symbol-light-success me-3" }
const _hoisted_11 = {
  class: "text-dark-50 text-hover-primary cursor-pointer",
  style: {"line-height":"1.25"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_14 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_DialogDetails = _resolveComponent("DialogDetails")!
  const _component_ModalRegister = _resolveComponent("ModalRegister")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.filter.option,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.option) = $event)),
            class: "me-4 w-250px",
            placeholder: "Select"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeFilter, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_input, {
            modelValue: _ctx.filter.text,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.text) = $event)),
            class: "w-350px",
            placeholder: "Buscar...",
            clearable: "",
            onKeypress: _withKeys(_ctx.getData, ["enter"]),
            onClear: _ctx.getData
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "dark",
                content: "Buscar",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.getData
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onKeypress", "onClear"])
        ]),
        _hoisted_6
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _ctx.listPersons,
        border: "",
        "table-layout": 'auto'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "idperson",
            label: "ID",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "docnumber",
            label: "Documento",
            width: "120"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(scope.row.docname), 1),
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(scope.row.docnumber), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "persona",
            label: "Participante"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_avatar, {
                    shape: "square",
                    size: 'small',
                    fit: "contain",
                    src: scope.row.photo,
                    class: _normalizeClass('border')
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(scope.row.firstname), 1),
                  _hoisted_12,
                  _createElementVNode("span", null, _toDisplayString(scope.row.lastname + ' ' + scope.row.surname), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "gender",
            label: "Sexo",
            width: "60",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              (scope.row.gender == 'M')
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(scope.row.gender), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(scope.row.gender), 1))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "birthday",
            label: "Nacimiento",
            width: "150",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "Estado",
            width: "120",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: _normalizeClass('badge badge-' + scope.row.status_class)
              }, _toDisplayString(scope.row.status_name), 3)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "created_at",
            label: "Registrado",
            width: "180",
            align: "center"
          }),
          (_ctx.username?.idperfil != 4)
            ? (_openBlock(), _createBlock(_component_el_table_column, { key: 0 }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("i", {
                    class: "fs-2 bi bi-pencil text-hover-primary",
                    onClick: ($event: any) => (_ctx.openModalDetails(row))
                  }, null, 8, _hoisted_15)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.loading]
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_el_pagination, {
          class: "mt-4",
          "current-page": _ctx.currentPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPage) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [100, 200, 300, 400],
          small: false,
          background: true,
          layout: "total, prev, pager, next",
          total: _ctx.totalItems,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_DialogDetails),
    _createVNode(_component_ModalRegister, { onOnResponse: _ctx.onResponse }, null, 8, ["onOnResponse"])
  ], 64))
}